<div class="bg-primary-100">
  <!-- #Region Desktop -->
  <div id="como-funciona-operaciones" class="pt-5 container fadein d-none d-lg-block">
    <div class="mb-4 text-center">
      <p class="tab-ancla secondary-factoring-600 mb-2">NUESTRAS OPERACIONES</p>
      <h2 class="primary-900">Tipos de operaciones</h2>
    </div>
    @if(isLoading || isApiCifrasError){
      <div class="bg-neutral-0 border-radius-20 s-py-48">
          <app-is-loading [type]="'text'" [text]="'Cargando datos'" [customClass]="'p1-medium primary-800'"></app-is-loading>
      </div>
    }
    @else if(cifrasWeb){
    <div class="row">
      @for (operacion of operacionesData; track $index) {
      <div class="col-lg-4 card-operacion pointer" (click)="setOperacion(operacion.id)">
        <div class="card-content border-radius-8 shadow-4 p-4 d-flex align-items-center bg-neutral-0">
          <app-sellos [tipoOperacionCodigo]="operacion.tipoOperacionCodigo" [size]="50"></app-sellos>
          <div class="d-flex justify-content-between w-100">
            <div class="d-inline-flex flex-column justify-content-center ms-3">
              <p class="p1-bold primary-900 s-mb-4">{{operacion.titulo}}</p>
              <p class="p2-bold primary-800 s-mb-4">{{operacion.tipoPerfil}}</p>
              <p class="p2-medium primary-800">{{operacion.rentaAnualizada}}</p>
            </div>
            <div class="d-flex align-items-center">
              <span class="material-symbols-outlined primary-900 mat-icon-size-30"
                [ngClass]="{'dropdown-arrow filled': activeOperacionNum === operacion.id && isOpenOperacion}">arrow_drop_down_circle</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    @if (isOpenOperacion) {
    <div class="d-none d-lg-block fadein">
      <div class="shadow-4 bg-neutral-0 border-radius-8 s-mt-16 s-p-24">
        <p class="p-display-bold primary-900">¿Qué ofrecemos?</p>
        <div class="s-mt-16">
          @for (texto of textosDesplegable; track $index; let isLast = $last) {
          <div class="d-flex" [ngClass]="{'s-mb-12': !isLast}">
            <div class="me-3">
              <span class="material-symbols-outlined secondary-factoring-600">keyboard_double_arrow_right</span>
            </div>
            <p class="p1-regular primary-900">{{texto}}</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    }

  </div>
  <!-- #endregion Desktop -->

  <!-- #Region Mobile -->
  <div id="como-funciona-operaciones-mb" class="pt-5 d-lg-none" [ngClass]="{'container': !isMobile}">
    <div class="mb-4 text-center">
      <p class="tab-ancla secondary-factoring-600">NUESTRAS OPERACIONES</p>
      <h2 class="primary-900">Tipos de operaciones</h2>
    </div>
    @for (operacion of operacionesData; track operacion.id) {
    <div class="border-radius-8 shadow-4 bg-neutral-0 s-py-24 s-px-16 s-mb-8 d-flex align-items-center pointer fadein"
      (click)="setOperacion(operacion.id)">
      <app-sellos [tipoOperacionCodigo]="operacion.tipoOperacionCodigo" [size]="50"></app-sellos>
      <div class="d-flex justify-content-between w-100">
        <div class="d-inline-flex flex-column justify-content-center ms-3">
          <p class="p1-bold primary-900 s-mb-4">{{operacion.titulo}}</p>
          <p class="p2-bold primary-800 s-mb-4">{{operacion.tipoPerfil}}</p>
          <p class="p2-medium primary-800">{{operacion.rentaAnualizada}}</p>
        </div>
        <div class="d-flex align-items-center">
          <span class="material-symbols-outlined primary-900 mat-icon-size-30"
            [ngClass]="{'dropdown-arrow filled': activeOperacionNum === operacion.id && isOpenOperacion}">arrow_drop_down_circle</span>
        </div>
      </div>
    </div>
    @if (isOpenOperacion && activeOperacionNum === operacion.id) {
    <div class="d-lg-none s-mb-16">
      <div class="shadow-4 bg-neutral-0 border-radius-8 s-mt-8 s-p-24">
        <p class="p-display-bold primary-900">¿Qué ofrecemos?</p>
        <div class="row s-mt-16">
          @for (texto of textosDesplegable; track $index; let isLast = $last) {
          <div class="d-flex" [ngClass]="{'s-mb-12': !isLast}">
            <div class="me-3">
              <span class="material-symbols-outlined secondary-factoring-600">keyboard_double_arrow_right</span>
            </div>
            <p class="p1-regular primary-900">{{texto}}</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    }
  </div>
  <!-- #endregion Mobile -->

  <div class="text-center s-mt-24 s-pb-48">
    @if (isPlatformFactoring) {
    <app-btn-link [linkTitle]="'Cómo funciona SEGO Factoring'" [linkUrl]="'/como-funciona'"></app-btn-link>
    }@else {
    <app-btn-link [linkTitle]="'Cómo funciona SEGO Factoring'" [linkType]="'href'"
      [linkUrl]="domainUrl + '/como-funciona'"></app-btn-link>
    }
  </div>
</div>
